module.exports = __webpack_public_path__ + "img/logo.9b62256e.png";